module.exports = __webpack_public_path__ + "img/og-logo.5adc8537.webp";